module.exports = __webpack_public_path__ + "img/jcb.df610026.svg";